import userApi from '@/modules/user-api';

export default {

	getUser(){
		return userApi.getUser();
	},

	getAddresses() {
		return userApi.getAddresses();
	},

	getExportStatus() {
		return userApi.getExportStatus();
	},

	getCountryByIp() {
		return userApi.getCountryByIp();
	},

	createAddress(payload) {
		return userApi.createAddress(payload);
	},

	updateUser(payload) {
		return userApi.updateUser(payload);
	},

	changePassword(payload) {
		return userApi.changePassword(payload);
	},

	changeEmail(payload) {
		return userApi.changeEmail(payload);
	},

	confirmEmail(payload) {
		return userApi.confirmEmail(payload);
	},

	verifyEmail(payload) {
		return userApi.verifyEmail(payload);
	},

	getEmailVerified() {
		return userApi.getEmailVerified();
	},

	createTfa() {
		return userApi.createTfa();
	},

	enableTfa(payload) {
		return userApi.enableTfa(payload);
	},

	disableTfa(payload) {
		return userApi.disableTfa(payload);
	},

	deleteAccount(payload) {
		return userApi.deleteAccount(payload);
	}

};



// WEBPACK FOOTER //
// ./src/modules/user-service.js